import loadable from '@loadable/component';

// apis
import newsApi from './apis/newsApi';
import researchApi from './apis/researchApi';

// helpers
import { sharedLoggerApi } from 'shared-helpers';
import { handleBodyLinks, handleNewsBodyOperations } from './utilities/helpers';
import { PUBLISHING_STATUS } from './utilities/constants';

// pages
const NewsDir = loadable(() =>
    import(/* webpackChunkName: "NewsDir" */ './pages/news/NewsDirectory'),
);
const SingleNews = loadable(() =>
    import(/* webpackChunkName: "SingleNews" */ './pages/news/SingleNews'),
);
const Research = loadable(() => import(/* webpackChunkName: "Research" */ './pages/Research'));
const SingleResearch = loadable(() =>
    import(/* webpackChunkName: "SingleResearch" */ './pages/Research/SingleResearch'),
);

// microfe
const NoMatch = loadable(() =>
    import(/* webpackChunkName: "NoMatch" */ '/src/micro-frontends/NoMatch'),
);

const loggerApi = sharedLoggerApi;

const routes = [
    {
        path: '/not-found',
        exact: true,
        component: NoMatch,
    },
    // news routes
    {
        path: '/news',
        exact: true,
        component: NewsDir,
        fetchInitialData: async (path = "", token = "", refreshToken = "") => {
            try {
                const result = await newsApi.getFeaturedNews(token, refreshToken);
                return result;
            } catch (error) {
                let userId = ''; // TODO add it
                loggerApi.logError(userId, 'Featured news', error);
                return [];
            }
        },
    },
    {
        path: '/news/:slug',
        exact: true,
        component: SingleNews,
        fetchInitialData: async (path, token = "", refreshToken = "") => {
            // Changing old structure links to new structure on server.
            const result = await newsApi.fetchNewsDetails(path.split('/')[2], token, refreshToken);
            if (result.is_published === PUBLISHING_STATUS.unpublished) {
                return 404;
            }

            const contentBody = await handleNewsBodyOperations(result, token, refreshToken);
            return contentBody;
        },
    },
    {
        path: '/en-:iso/news',
        exact: true,
        component: NewsDir,
    },
    {
        path: '/en-:iso/news/:category',
        exact: true,
        component: NewsDir,
    },

    // research routes
    {
        path: '/research',
        exact: true,
        component: Research,
        fetchInitialData: async (path = "", token = "", refreshToken = "") => {
            try {
                const result = await researchApi.getFeaturedResearch(token, refreshToken);
                return result;
            } catch (error) {
                let userId = ''; // TODO add it
                // loggerApi.logError(userId, 'Featured research', error);
                return [];
            }
        },
    },
    {
        path: '/research/:slug',
        exact: true,
        component: SingleResearch,
        fetchInitialData: async (path, token = "", refreshToken = "") => {

            // Get the id from the slug string, example: uae-report-3223
            let slug = path.split('/')[2];
            let id = parseInt(slug.split('-').pop());
            if (!Number.isInteger(id)) {
                return 404;
            }

            // fetch research details
            let result = await researchApi.fetchResearchDetails(id, token, refreshToken);

            if (result && result == 404) {
                return 404;
            } else if (result.researchData.is_published === PUBLISHING_STATUS.unpublished) {
                return 404;
            }

            // research content is in 2 form fields: body and full_description
            // handle ssr and links for both
            let tempData = result.researchData;
            let { full_description, body } = tempData;

            tempData.body = "";
            if (full_description) {
                tempData.body += full_description;
            }
            if (body) {
                tempData.body += body;
            }
            
            // change old structure links to new structure on server
            tempData = handleBodyLinks(tempData);

            result.researchData = tempData;

            return result;
        },
    },
];

export default routes;